export const joinStrings = (s1, s2, sep = ' ') =>
  [s1, s2]
    .filter((it) => it)
    .map((it) => it.trim())
    .filter((it) => it.length)
    .join(sep)

export const getShortAddress = (city, state, zip) => joinStrings(city, joinStrings(state, zip), ', ')
